module.exports = __webpack_public_path__ + "media/images/pic/blank-d2a4c5ba10e6a2af5f4d6e2c1cd654b4.svg";